

function toTimeStamp(dateString){
  return new Date(dateString) - 0
}
function getDistanceDays(startData,endData){
  const startData_timeStamp = toTimeStamp(startData)
   const endData_timeStamp = toTimeStamp(endData)
   let max = endData_timeStamp, min = startData_timeStamp
  return (max-min)/(24*60*60*1000)
}
export{
  getDistanceDays,
}



// WEBPACK FOOTER //
// ./src/common/js/periodOfValidity.js